export default [
  {
    path: '/coverage-area',
    name: 'coverage-area',
    component: () => import('@/views/pages/komship/coverage-area/CoverageArea.vue'),
    meta: {
      resource: 'Komship',
      navActiveLink: 'coverage-area',
      action: 'manage',
    },
  },
  {
    path: '/coverage-area/pengajuan',
    name: 'coverage-area-upload',
    component: () => import('@/views/pages/komship/coverage-area/FormChangeCoverageArea.vue'),
    meta: {
      resource: 'Komship',
      navActiveLink: 'coverage-area',
      action: 'manage',
    },
  },
  {
    path: '/coverage-area/acuan',
    name: 'coverage-area-acuan',
    component: () => import('@/views/pages/komship/coverage-area/DataAcuan.vue'),
    meta: {
      resource: 'Komship',
      navActiveLink: 'coverage-area',
      action: 'manage',
    },
  },
  {
    path: '/coverage-area/detail/:city',
    name: 'coverage-area-detail',
    component: () => import('@/views/pages/komship/coverage-area/DetailArea.vue'),
    meta: {
      resource: 'Komship',
      navActiveLink: 'coverage-area',
      action: 'manage',
    },
  },
]
